import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Fieldset } from "primereact/fieldset";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../routes";

type SovHelperModalProps = {
  reportId: string;
  visible: boolean;
  setVisible: (value: boolean) => void;
};

export const SovHelperModal: React.FC<SovHelperModalProps> = ({
  reportId,
  visible,
  setVisible,
}) => {
  const navigate = useNavigate();

  return (
    <Dialog
      header="I Don't See My SOV File"
      visible={visible}
      style={{
        width: "calc(100vw - 72px)",
        height: "calc(100vh - 72px)",
      }}
      onHide={() => setVisible(false)}
    >
      <Fieldset legend="Step 1: Attachment Classification">
        If you don't see your file listed as an SOV option, it's possible that
        the file wasn't classified correctly during processing. The first thing
        to check is that the file was classifield as an "Sov Spreadsheet" on the{" "}
        <Button
          style={{ padding: "0px" }}
          link
          label="Attachments tab."
          onClick={() =>
            navigate(ROUTES.DASHBOARD_REPORT(reportId, "attachments"), {
              replace: true,
            })
          }
        />
      </Fieldset>
      <Fieldset
        legend="Step 2: Manual Excel File Creation"
        style={{ marginTop: "20px" }}
      >
        <div>
          If your file was correctly classified but you don't see it in the SOV
          dropdown, then we likely couldn't extract any addresses from that file
          or sheet. This can happen for a few reasons:
        </div>
        <br />
        <div>
          • The file had an unexpected format. If the file has information for
          multiple addresses contained in a single row, or is missing certain
          columns, we won't be able to extract information.
        </div>
        <br />
        <div>
          In order to fix this issue, you can manually enter information into an
          excel template and upload it as an additional attachment on the{" "}
          <Button
            style={{ padding: "0px" }}
            link
            label="Attachments tab."
            onClick={() =>
              navigate(ROUTES.DASHBOARD_REPORT(reportId, "attachments"), {
                replace: true,
              })
            }
          />
        </div>
        <br />
        <Button
          label="Download Excel Template"
          outlined
          onClick={() => {
            const link = document.createElement("a");
            link.href = process.env.PUBLIC_URL + "/LuminorSovTemplate.xlsx";
            link.download = "LuminorSovTemplate.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}
        />
      </Fieldset>
    </Dialog>
  );
};
